<template>
    <div class="summaryAccolades">
        <div class="columns is-mobile has-text-centered">
            <div class="column">
                <i class="fas fa-award winner" style="padding: 8px;"></i>Finals Champ: <b>{{ accolades.finalsChamp }}</b>
            </div>
            <div class="column">
                <i class="fas fa-arrow-up" style="padding: 8px;"></i>Most Improved: <b>{{ accolades.mostImproved }}</b>
            </div>
            <div class="column">
                <!--<i class="fas fa-calculator" style="padding: 8px;"></i>-->Most 3's: <b>{{ accolades.mostThrees }}</b>
            </div>
            <div class="column">
                <i class="fas fa-bullseye" style="padding: 8px;"></i>Most Bullseyes: <b>{{ accolades.mostBullsEyes }}</b>
            </div>
            <div class="column">
                <!--<i class="fas fa-bullseye" style="padding: 8px;"></i>-->Consec. Bullseyes: <b>{{ accolades.mostConsecutiveBulls }}</b>
            </div>
            <div class="column">
                <i class="fas fa-check" style="padding: 8px;"></i>Best Score: <b>{{ accolades.bestScore }}</b>            
            </div>
            <!--
            <div class="column">
                <i class="fas fa-bullseye" style="padding: 8px;"></i>Total Bullseyes: <b>{{ accolades.totalBullsEyes }}</b>
            </div>
            -->
        </div>
    </div>
</template>

<style>
.summaryAccolades, h2 {
    color: black !important;
    font-size: 0.8em;
}
.summaryAccolades .columns .column {
    border: solid black 1px;
}
</style>

<script>
export default {
  name: "SummaryAccolades",
  props: {
    summary: null,
    accolades: null,
    isFinals: true
  },
}
</script>